import config from '__api/config';
import { zqhdApi } from '__api/zqhd/creatZqhdRequest';

/* 完成任务 */
type GetAcConfigReq = {
  acNo: string; //活动编号
  paramCode: string[]; //编码
};
type requestReq = {
  notice: string;
};
interface GetAcConfigRes {
  data: requestReq;
}
/*完成任务*/
export async function getAcConfig(request: GetAcConfigReq) {
  const url = config.zqhpLink + '/activity/getActivityPrams';
  return zqhdApi.fetch<GetAcConfigRes>(url, request);
}
